import { Routes, Route, Navigate } from 'react-router-dom';
import HomeScreen from './screens/HomeScreen.jsx';
import CaptureScreen from './screens/CaptureScreen.jsx';
import PreviewScreen from './screens/PreviewScreen.jsx';
import SettingsScreen from './screens/SettingsScreen.jsx';
import LandingScreen from './screens/LandingScreen.jsx';
import PrivacyScreen from './screens/PrivacyScreen.jsx';
import TermsScreen from './screens/TermsScreen.jsx';
import AppShell from './components/AppShell.jsx';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingScreen />} />
      <Route path="/privacy" element={<PrivacyScreen />} />
      <Route path="/terms" element={<TermsScreen />} />
      <Route element={<AppShell />}>
        <Route path="/app" element={<HomeScreen />} />
        <Route path="/capture/:category" element={<CaptureScreen />} />
        <Route path="/preview" element={<PreviewScreen />} />
        <Route path="/settings" element={<SettingsScreen />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
